export default __webpack_public_path__ + "static/media/Marathi_bf_1.c4d63916.mp3";